import SEOArticleLayout from "@/components/feature/SEOArticleLayout";

const IMAGE = "https://readdy.ai/api/search-image?query=Hands%20typing%20on%20keyboard%20with%20warm%20coffee%20beside%20monitor%20showing%20tutorial%20interface%2C%20cozy%20home%20office%20setup%2C%20soft%20morning%20light%20through%20window%2C%20minimal%20Scandinavian%20workspace%2C%20cream%20and%20oak%20tones%2C%20friendly%20atmosphere&width=900&height=1100&seq=seo-article-tutoriel-v3&orientation=portrait";

export default function TutorielPage() {
  return (
    <SEOArticleLayout
      title="Tutoriel Hipobuy Spreadsheet : Guide Pratique"
      subtitle="Un tutoriel complet pour maîtriser le hipobuy spreadsheet. De la prise en main aux fonctionnalités avancées, devenez un expert du suivi e-commerce."
      heroImageUrl={IMAGE}
      heroImageAlt="Tutoriel Hipobuy Spreadsheet"
    >
      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Bienvenue dans ce tutoriel</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Ce tutoriel vous guide pas à pas dans la prise en main du <strong>hipobuy spreadsheet</strong>. Que vous soyez débutant ou utilisateur intermédiaire, vous trouverez ici toutes les informations pour exploiter pleinement cet outil de suivi e-commerce.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Partie 1 : Premiers pas</h2>
        <div className="space-y-4">
          <div className="p-4 bg-background-100 rounded-2xl">
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-1">Création de votre compte</h4>
            <p className="text-xs text-foreground-500">Rendez-vous sur la plateforme officielle et créez un compte. L'inscription prend moins de 2 minutes.</p>
          </div>
          <div className="p-4 bg-background-100 rounded-2xl">
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-1">Import de votre catalogue</h4>
            <p className="text-xs text-foreground-500">Importez vos produits existants via fichier CSV ou connectez directement votre boutique Shopify.</p>
          </div>
          <div className="p-4 bg-background-100 rounded-2xl">
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-1">Configuration des alertes</h4>
            <p className="text-xs text-foreground-500">Définissez vos seuils d'alerte pour être notifié des changements de prix et des ruptures de stock imminentes.</p>
          </div>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Partie 2 : Fonctionnalités avancées</h2>
        <div className="space-y-4">
          <div className="p-4 bg-background-100 rounded-2xl">
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-1">Analyse concurrentielle</h4>
            <p className="text-xs text-foreground-500">Configurez vos concurrents à surveiller et laissez le <strong>hipobuy spreadsheet</strong> analyser leurs prix automatiquement.</p>
          </div>
          <div className="p-4 bg-background-100 rounded-2xl">
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-1">Tableaux de bord personnalisés</h4>
            <p className="text-xs text-foreground-500">Créez des dashboards adaptés à vos KPIs : marge par produit, tendances saisonnières, produits les plus rentables.</p>
          </div>
          <div className="p-4 bg-background-100 rounded-2xl">
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-1">Export et rapports</h4>
            <p className="text-xs text-foreground-500">Générez des rapports PDF ou exportez vos données pour vos analyses externes ou votre comptabilité.</p>
          </div>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Astuces de pro</h2>
        <div className="space-y-2">
          {[
            "Utilisez les alertes de prix pour réagir en moins de 24h aux changements du marché",
            "Programmez des revues hebdomadaires de vos tableaux de bord pour suivre l'évolution de vos marges",
            "Connectez toutes vos plateformes de vente pour une vue unifiée de votre catalogue",
            "Exploitez les recommandations automatiques pour identifier les produits à fort potentiel",
          ].map((tip, i) => (
            <div key={i} className="flex items-start gap-2">
              <i className="ri-star-fill text-accent-500 text-xs flex-shrink-0 mt-1"></i>
              <span className="text-xs text-foreground-600">{tip}</span>
            </div>
          ))}
        </div>
      </section>

      <div className="mt-8 p-6 bg-accent-50 rounded-2xl border border-accent-100 text-center">
        <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">Mettez ce tutoriel en pratique</h3>
        <p className="text-sm text-foreground-500 mb-4">Le meilleur moyen d'apprendre, c'est de pratiquer. Lancez-vous avec le hipobuy spreadsheet.</p>
        <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer">
          Commencer le Tutoriel
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </SEOArticleLayout>
  );
}